module.exports = __webpack_public_path__ + "img/ssl.0d0b24d8.png";